enum DomainVerificationStatus {
  VERIFICATION_STATUS_UNSPECIFIED = 'VERIFICATION_STATUS_UNSPECIFIED',
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
  FAILED = 'FAILED'
}

export enum DomainType {
  DOMAIN_TYPE_UNSPECIFIED = 'DOMAIN_TYPE_UNSPECIFIED',
  ALLOWED_EMAIL_DOMAIN = 'ALLOWED_EMAIL_DOMAIN',
  ORGANIZATION_DOMAIN = 'ORGANIZATION_DOMAIN'
}

export interface DomainData {
  id?: string;
  domain: string;
  environmentId?: string;
  organizationId?: string;
  connectionId?: string;
  txtRecordKey?: string;
  txtRecordSecret?: string;
  verificationStatus?: DomainVerificationStatus;
  domainType?: DomainType;
  createTime?: string;
}

export interface DomainListResponse {
  pageSize: number;
  pageNumber: number;
  domains: DomainData[];
}

export enum DnsRecordTypes {
  CNAME = 'CNAME',
  CAA = 'CAA'
}

export interface DnsRecord {
  hostName: string;
  type: DnsRecordTypes;
  value: string;
}
